import {Box, Button} from '@mui/material';
import {useNavigate} from 'react-router-dom';

export default function NavButton(props: {type: 'HOME' | 'BACK' | 'HISTORY'}) {
	const {type} = props;

	const navigate = useNavigate();

	const handleNavigation = () => {
		if (type === 'BACK') navigate(-1);
		else {
			const urls = {HOME: '/', HISTORY: '/history'};
			navigate(urls[type as 'HOME' | 'HISTORY'], {replace: true});
		}
	};

	const desc = {HOME: 'Back to Home', BACK: 'Go Back', HISTORY: 'Show History'};

	return (
		<Box padding="20px 0px">
			<Button fullWidth onClick={handleNavigation}>
				{desc[type]}
			</Button>
		</Box>
	);
}
